import { render } from "./WhatsappFloatingButton.vue?vue&type=template&id=5360a35a"
import script from "./WhatsappFloatingButton.vue?vue&type=script&lang=js"
export * from "./WhatsappFloatingButton.vue?vue&type=script&lang=js"

import "./WhatsappFloatingButton.vue?vue&type=style&index=0&id=5360a35a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__